export const APP_NAME = "OwlEvents";
